import FeedbackLanding from "../components/FeedbackLanding/FeedbackLanding";

export default function Feedback() {
  return <FeedbackLanding />;
}
